export const DEFAULT_YEARS_AHEAD = 15;
export const DEFAULT_PAST_START_DATE = new Date("1900-01-01");
export const DEFAULT_START_DATE = new Date("2000-01-01");
export const DEFAULT_TIME = "09:00";
export const DEFAULT_TIME_12HR = "09:00 AM";
export const DAYS_OF_WEEK = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
export const HEALTH_PROFILE_URL = "/profile/health-profile";
export const PAGE_SIZE = 10;
export const MAATRA_VIDEO_URL = "https://www.youtube.com/watch?v=ZZdYMDAAkxo";
export const MAATRA_DASHBOARD_VIDEO_URL =
  "https://www.youtube.com/watch?v=4Rkwfrtv4jQ";

export const VIDEO_REMINDER = "https://youtube.com/shorts/fMEgAvV8bwo";
export const VIDEO_LAB_TRENDS = "https://youtube.com/shorts/vOiwiyVK6Co";
export const VIDEO_DOCUMENTS = "https://youtube.com/shorts/5sBEgIX-qQc";
export const VIDEO_HEALTH_SUMMARY = "https://youtube.com/shorts/K_V0rr3I6-s";
export const VIDEO_FAMILY_TAB = "https://youtube.com/shorts/OiAR4ba4lwU";
export const VIDEO_EMERGENCY_CARD = "https://youtube.com/shorts/eESvNKImIco";
export const VIDEO_SEARCH = "https://youtube.com/shorts/Lk9KG6MhT1g";

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB in bytes
